import React from 'react';
import { valuesBand, weeks } from '../data/content';
import { SectionHeading } from './SectionHeading';

/** Belt colors for the value chips (decorative only: every school uses its own belt order) */
const belts = ['#FFFFFF', '#FFD60A', '#FF8C1A', '#21A366', '#1E88E5', '#9B6BFF', '#E63946', '#B07A45'];

/** One value talk every week. v2: chips with the real values of the 52 classes (the 3 age levels moved to the
 *  "in every class" features, so this band is shorter on mobile). */
export function ValuesBand() {
  const values = Array.from(new Set(weeks.map(w => w.value)));
  const shown = values.slice(0, valuesBand.show);
  const rest = values.length - shown.length;
  return <section aria-labelledby="values-title" className="bg-ink py-12 md:py-16" data-id="element-251" data-mp="1j2f1g3ln49xf">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-252" data-mp="2phy5c36owurr">
        <SectionHeading id="values-title" tone="dark" eyebrow={valuesBand.eyebrow} title={valuesBand.title} sub={valuesBand.sub} data-id="element-253" data-mp="2ph6awvotx332" />

        <ul className="mx-auto mt-8 flex max-w-[900px] flex-wrap justify-center gap-2 md:mt-10 md:gap-2.5" data-id="element-254" data-mp="2uivks80bfapk">
          {shown.map((v, i) => <li key={v} className="flex items-center gap-2 rounded-lg bg-white/[0.07] py-2 pl-2 pr-3 font-display text-[13px] font-extrabold uppercase tracking-tight text-white ring-1 ring-white/10 md:text-[14px]" data-id="element-255" data-mp="111lzimn4z2es" data-mpi={i}>
              <span aria-hidden="true" className="h-4 w-1.5 rounded-sm" style={{
            background: belts[i % belts.length]
          }} data-id="element-256" data-mp="s3ib9ikrnrja" />
              {v}
            </li>)}
          {rest > 0 && <li className="flex items-center rounded-lg bg-sun px-3 py-2 font-display text-[13px] font-black uppercase tracking-tight text-ink md:text-[14px]" data-id="element-257" data-mp="i9jdswvn0vxo">
              + {rest} {valuesBand.moreLabel}
            </li>}
        </ul>
      </div>
    </section>;
}